module.exports = __webpack_public_path__ + "static/media/bell.dfcb3372.svg";